// Sesuaikan FA di draft WO — K136 butir 2 (Owner 31 Agu 2026: "draft wo tersebut fa fa nya bisa
// diadjust oleh admin produksi digantikan fa lain, namun tentunya tetap persetujuan kepala cabang di
// akhir. untuk fa yg diadjust harus ada alasan, tercatat dan terecord dengan baik.").
//
// ⛔ LAHIR DARI SENSUS PINTU (23 Sep 2026): `POST /wo/{id}/sesuaikan-fa` berdiri sejak 31 Agustus
//    tanpa SATU kontrol pun — WODetail hanya menampilkan riwayat penyesuaian yang tidak pernah bisa
//    dibuat dari layar. Komponen ini hanya PINTU: status DRAFT, wilayah, FA yang sudah dipegang WO
//    lain, dan WO yang jadi kosong seluruhnya ditolak backend (`draft_wo_service.sesuaikan_fa`).
import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { apiErrorMessage } from "../../lib/inventoryApi";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import PilihFA from "./PilihFA";

//: Cermin CHECK database alasan (min 10) — backend tetap penjaganya.
const ALASAN_MIN = 10;

export default function SesuaikanFaWo({ wo, onSelesai }) {
  const [buka, setBuka] = useState(false);
  const [hapus, setHapus] = useState([]);
  const [tambah, setTambah] = useState([]);         // [{ id, fa_number }]
  const [pilihan, setPilihan] = useState(null);
  const [alasan, setAlasan] = useState("");
  const [sibuk, setSibuk] = useState(false);
  const fas = wo.source_fas || [];

  const adaPerubahan = hapus.length > 0 || tambah.length > 0;
  const alasanSah = alasan.trim().length >= ALASAN_MIN;

  function tambahkan() {
    const f = pilihan?.fa;
    if (!f) return;
    if (fas.some((x) => x.id === f.id) || tambah.some((x) => x.id === f.id)) {
      toast.error(`${f.fa_number} sudah ada di WO ini.`);
      return;
    }
    setTambah([...tambah, { id: f.id, fa_number: f.fa_number }]);
    setPilihan(null);
  }

  async function simpan() {
    setSibuk(true);
    try {
      await api.post(`/wo/${wo.id}/sesuaikan-fa`, {
        tambah: tambah.map((x) => x.id), hapus, alasan: alasan.trim(),
      });
      toast.success("FA di draft WO disesuaikan — tercatat bersama alasannya.");
      setBuka(false); setHapus([]); setTambah([]); setAlasan("");
      onSelesai && onSelesai();
    } catch (e) {
      toast.error(apiErrorMessage(e, "Penyesuaian FA ditolak."));
    } finally {
      setSibuk(false);
    }
  }

  if (!buka) {
    return (
      <Button variant="outline" className="w-full" onClick={() => setBuka(true)} data-testid="wo-sesuaikan-fa-btn">
        Sesuaikan FA
      </Button>
    );
  }
  return (
    <div className="rounded-md border border-border p-3 space-y-3 text-sm" data-testid="wo-sesuaikan-fa">
      <div className="font-medium">Sesuaikan FA di draft {wo.wo_number}</div>
      <div>
        <div className="text-xs text-muted-foreground mb-1">Lepas dari WO</div>
        {fas.map((f) => (
          <label key={f.id} className="flex items-center gap-2 py-0.5">
            <input type="checkbox" checked={hapus.includes(f.id)}
                   onChange={(e) => setHapus(e.target.checked ? [...hapus, f.id] : hapus.filter((x) => x !== f.id))}
                   data-testid={`wo-sesuaikan-hapus-${f.id}`} />
            <span className="font-mono">{f.fa_number}</span>
            {/* K206: nama customer hanya dikirim ke Owner/KC/CS. */}
            {f.customer_name && <span className="text-muted-foreground">— {f.customer_name}</span>}
          </label>
        ))}
      </div>
      <div>
        <div className="text-xs text-muted-foreground mb-1">Tambah FA</div>
        <div className="flex gap-2 items-start">
          <div className="flex-1"><PilihFA value={pilihan} onChange={setPilihan} denganWo={false} testId="wo-sesuaikan-pilih-fa" /></div>
          <Button size="sm" variant="outline" onClick={tambahkan} disabled={!pilihan?.fa}
                  data-testid="wo-sesuaikan-tambah-btn">Tambah</Button>
        </div>
        {tambah.map((f) => (
          <div key={f.id} className="flex items-center gap-2 py-0.5">
            <span className="font-mono">+ {f.fa_number}</span>
            <button type="button" className="text-xs underline text-muted-foreground"
                    onClick={() => setTambah(tambah.filter((x) => x.id !== f.id))}>batal</button>
          </div>
        ))}
      </div>
      <div>
        <div className="text-xs text-muted-foreground mb-1">Alasan (wajib, minimal {ALASAN_MIN} huruf — dibaca Kepala Cabang saat menyetujui)</div>
        <Textarea value={alasan} onChange={(e) => setAlasan(e.target.value)} rows={3} maxLength={1000}
                  data-testid="wo-sesuaikan-alasan" />
      </div>
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={() => setBuka(false)}>Batal</Button>
        <Button disabled={sibuk || !adaPerubahan || !alasanSah} onClick={simpan}
                data-testid="wo-sesuaikan-simpan">Simpan penyesuaian</Button>
      </div>
    </div>
  );
}
